const normalizeCompact = (text) =>
  String(text || "").toLowerCase().replace(/[\s\-_/]/g, "")

const querySegments = (query) =>
  query.trim().toLowerCase().split(/[\s\-_/]+/).filter(Boolean)

const compactPartsMatchInOrder = (text, parts) => {
  if (!parts.length) return false
  const compact = normalizeCompact(text)
  let pos = 0
  for (const part of parts) {
    const p = normalizeCompact(part)
    if (!p) continue
    const idx = compact.indexOf(p, pos)
    if (idx === -1) return false
    pos = idx + p.length
  }
  return true
}

export const shipmentMatchesSearch = (shipment, query) => {
  const q = query.trim().toLowerCase()
  if (!q) return true

  const segments = querySegments(q)
  const qCompact = normalizeCompact(q)
  const fields = [
    shipment.shipment_id,
    shipment.ml_sheet_id,
    shipment.sender_name,
    shipment.sender_contact,
    shipment.sender_email,
    shipment.sender_address,
    shipment.sender_location,
    shipment.receiver_name,
    shipment.receiver_contact,
    shipment.receiver_email,
    shipment.receiver_address,
    shipment.receiver_location,
    shipment.consigner_name,
    shipment.consignee_name,
    shipment.status,
    shipment.balance_amount != null ? String(shipment.balance_amount) : "",
    shipment.total_amount != null ? String(shipment.total_amount) : "",
    shipment.no_of_articles != null ? String(shipment.no_of_articles) : "",
    shipment.mode_of_payment,
  ]

  const haystack = fields.filter(Boolean).join(" ").toLowerCase()
  const haystackCompact = normalizeCompact(haystack)
  const shipmentId = String(shipment.shipment_id || "")

  return (
    haystack.includes(q) ||
    (qCompact.length > 0 && haystackCompact.includes(qCompact)) ||
    compactPartsMatchInOrder(haystack, segments) ||
    compactPartsMatchInOrder(shipmentId, segments)
  )
}
